export default __webpack_public_path__ + "36659ed8ff00ed936b18173863f34291.png";